window.onload = function () {
  (function ($) {
    document.querySelector("body").classList.add("loaded-doc");
    if ($(".swpb-wrapper")) {
      let dataDate = $(".swpb-wrapper").attr("data-date");
      var today = new Date();
      // set date for tomorrow
      //today.setDate(new Date().getDate()+1);
      var dd = today.getDate();
      var mm = today.getMonth() + 1;
      var yy = today.getFullYear();
      switch (mm) {
        case 1:
          var m = "January";
          break;
        case 2:
          var m = "February";
          break;
        case 3:
          var m = "March";
          break;
        case 4:
          var m = "April";
          break;
        case 5:
          var m = "May";
          break;
        case 6:
          var m = "June";
          break;
        case 7:
          var m = "July";
          break;
        case 8:
          var m = "August";
          break;
        case 9:
          var m = "September";
          break;
        case 10:
          var m = "October";
          break;
        case 11:
          var m = "November";
          break;
        case 12:
          var m = "December";
          break;
      }
      // May 14, 2021 23:59:00
      var upDate = m + " " + dd + ", " + yy + " 23:59:00";
      if (dataDate) {
        var countDownDate = new Date(dataDate).getTime();
      } else {
        var countDownDate = new Date(upDate).getTime();
      }

      // Update the count down every 1 second
      var x = setInterval(function () {
        // Get today's date and time
        var now = new Date().getTime();

        // Find the distance between now and the count down date
        var distance = countDownDate - now;

        // Time calculations for days, hours, minutes and seconds
        var days = Math.floor(distance / (1000 * 60 * 60 * 24));
        var hours = Math.floor(
          (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
        );
        var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        var seconds = Math.floor((distance % (1000 * 60)) / 1000);

        // Display the result in the element with id="demo"
        document.getElementById("timerOuterDiv").innerHTML =
          days + "d " + hours + "h " + minutes + "m " + seconds + "s ";

        // If the count down is finished, write some text
        if (distance < 0) {
          clearInterval(x);
          document.getElementById("timerOuterDiv").innerHTML = "EXPIRED";
          $(".sitewide-promo-wrapper").addClass("hidden");
        } else {
          $(".sitewide-promo-wrapper").removeClass("hidden");
        }
      }, 1000);
    }

    if (document.querySelector(".m-h .nav-trigger")) {
      document
        .querySelector(".m-h .nav-trigger")
        .addEventListener("click", function (e) {
          document.querySelector("body").classList.toggle("mobile-nav-active");
          e.preventDefault();
        });
    }

    if ($(".promo-image-wrapper.hidden").length > 0) {
      if ($(".swpb-wrapper").length > 0) {
        let colimg = $(".swpb-wrapper").attr("data-image");
        $(".promo-image-wrapper").append("<img src='" + colimg + "'>");
        $(".promo-image-wrapper").removeClass("hidden").addClass("visible");
      }
    }

    $(document).on("click", ".accordion-new h4", function () {
      $(this)
        .parent()
        .parent()
        .find(".accordion-new")
        .not($(this).parent())
        .removeClass("active");
      $(this).parent().toggleClass("active");
      return false;
    });
    $(document).on("click", ".pdw-block .input-box", function () {
      $(this).find("input").focus();
    });
    window.pprice = 0;
    $(document).on("click", ".product-color-selector a", function () {
      let colorChoice = $(this).find("span").text();
      if ($(this).parent().hasClass("extra-label")) {
        if ($(".select-a-color.normal-spa-color .error").length > 0) {
          $(".select-a-color.normal-spa-color .error").remove();
        }
        if ($(".select-a-color.weather-shield .error").length > 0) {
          $(".select-a-color.weather-shield .error").remove();
        }

        $(this).parent().find("a").removeClass("selected");
        $(this).addClass("selected");
        if ($("#prdclr").find("option:selected").text() == colorChoice) {
          $(this).removeClass("selected");
          $("#prdclr").prop("selectedIndex", 0);
        } else {
          $(this)
            .parent()
            .parent()
            .find(".color-options option:selected")
            .prop("selected", false);
          $(this)
            .parent()
            .parent()
            .find(".color-options option[value='" + colorChoice + "']")
            .prop("selected", true);
        }
      }
      if ($(this).parent().hasClass("w-label")) {
        if ($(".select-a-color.normal-spa-color .error").length > 0) {
          $(".select-a-color.normal-spa-color .error").remove();
        }
        if ($(".select-a-color.weather-shield .error").length > 0) {
          $(".select-a-color.weather-shield .error").remove();
        }
        $(this).parent().find("a").not($(this)).removeClass("selected");
        $(this).toggleClass("selected");

        if (
          $("#wtshield").find("option:selected").text().trim() == colorChoice
        ) {
          let cwssv = $("#wtshield option:selected").val();
          let wsp = new Number(
            $("#wtshield option:selected").attr("data-price")
          );

          window.pprice = window.pprice - wsp;
          $(".product-total-price strong").text("$" + window.pprice.toFixed(2));
          window.prodToCart.forEach((element, index, array) => {
            if (element.id == cwssv) {
              window.prodToCart.pop(index);
            }
          });
          $("#wtshield").prop("selectedIndex", 0);
          $("#shopify-section-product-colors").removeClass("disabled-icon");
        } else {
          $("#wtshield option").each(function (i) {
            let tt = $(this).text();
            if (tt.trim() == colorChoice) {
              $(this).prop("selected", true);
              let wsp = new Number($(this).attr("data-price"));
              window.pprice = window.pprice + wsp;
              $(".product-total-price strong").text(
                "$" + window.pprice.toFixed(2)
              );
            }
          });
          $("#shopify-section-product-colors").addClass("disabled-icon");

          var csopid = $("#wtshield option:selected").val();

          if (
            $("#wtshield option:selected").length &&
            $("#wtshield option:selected").attr("data-price")
          ) {
            // let csop = new Number(
            //   $("#wtshield option:selected").attr("data-price")
            // );
            // window.pprice = window.pprice - csop;
            // window.prodToCart.forEach((element, index, array) => {
            //   if (element.id === csopid) {
            //     window.prodToCart.pop(index);
            //   }
            // });
          }

          window.prodToCart.push({
            id: csopid,
            quantity: 1,
          });
        }
        if ($("#prdwsclr").find("option:selected").text() == colorChoice) {
          $("#prdwsclr").prop("selectedIndex", 0);
        } else {
          $("#prdwsclr option").each(function () {
            let tt = $(this).text();
            if (tt == colorChoice) {
              $(this).prop("selected", true);
            }
          });
        }
      }
      return false;
    });
    $(document).on("click", ".tabs-wrapper .tw-nav a", function () {
      let tabTg = $(this).attr("href");
      $(
        ".tabs-wrapper .tw-nav a, .tabs-wrapper .tw-copy .copy-block"
      ).removeClass("active");
      $(this).addClass("active");
      $(tabTg).addClass("active");
      return false;
    });
    if ($(".wshield-carousel").length > 0) {
      $(".wshield-carousel").slick({
        slidesToShow: 1,
        arrows: false,
        dots: true,
        autoplay: true,
        autoplaySpeed: 6000,
        infinite: true,
        adaptiveHeight: false,
      });
    }
    if ($(".tabs-wrapper").length > 0) {
      $(".tabs-wrapper .tw-nav a:first").addClass("active");
      $(".tabs-wrapper .tw-copy .copy-block:first").addClass("active");
    }
    $(document).on("click", ".dd-filter p", function () {
      $(".dd-filter").not($(this).parent()).removeClass("active");
      $(this).parent().toggleClass("active");
    });
    $(document).on("click", ".m-h .search", function () {
      $(".modal.search").toggleClass("visible");
      return false;
    });
    if ($(".sidebar .model-selector ul li").length > 0) {
      $(".sidebar .model-selector").removeClass("hidden");
    }
    if (window.location.hash) {
      if (
        window.location.hash === "#all-brands" &&
        $(".collection-listing .sdb-left .collection-selector")
      ) {
        let correction = -124;
        $("html,body").animate(
          {
            scrollTop:
              $(".collection-selector.dd-filter").offset().top + correction,
          },
          1000
        );
        $(".collection-selector.dd-filter").toggleClass("active");
        $("body").addClass("fog");
        $(".collection-selector.dd-filter").css("z-index", "8000");
        setTimeout(function () {
          $("body").removeClass("fog");
          $(".collection-selector.dd-filter").removeAttr("style");
        }, 2000);
      }
      /*
          if(window.location.hash === "#select-by-shape" && $(".collection-listing .select-by-shape-wrapper").length > 0) {
            let correction = -84;
            $('html,body').animate({scrollTop: ($(".collection-hero").offset().top+correction)}, 1000);
          }
          */
      if (window.location.hash == "#faq-entry-3/") {
        let correction = -48;
        $("html,body").animate(
          { scrollTop: $("#faq-entry-3").offset().top + correction },
          1000
        );
        $("#faq-entry-3").toggleClass("active");
      }
    }
    if ($(".single-collection-title").length > 0) {
      let curUrl = window.location.href;
      curUrl = "/" + curUrl.substring(curUrl.indexOf("/collections") + 1);
      curUrl = curUrl.split("?")[0];
      $(".sidebar .dd-filter ul li").each(function () {
        let urlv = $("a", this).attr("href");
        if (urlv == curUrl) {
          $(this).addClass("current-item");
        }
      });
      if ($(".sdb-left.model-sidebar").length > 0) {
        let parentCol = $(".single-collection-title").text();
        parentCol = parentCol.substring(0, parentCol.indexOf(" - "));
        $(".sidebar .collection-selector.dd-filter ul li").each(function () {
          let clabel = $("a", this).text();
          if (clabel == parentCol) {
            $(this).addClass("current-item");
          }
        });
      }
    }

    if ($(".collection-listing").length > 0) {
      let curUrl = window.location.href;
      curUrl = "/" + curUrl.substring(curUrl.indexOf("/collections") + 1);
      curUrl = curUrl.split("?")[0];
      if (curUrl != "/collections/all/") {
        if (
          $(".collection-listing .model-parent-sidebar") ||
          $(".collection-listing .model-sidebar")
        ) {
          let correction = -24;
          $("html,body").animate(
            { scrollTop: $(".collection-hero").offset().top + correction },
            1000
          );
        }
      }
      if (curUrl == "/collections/all/") {
        $(".collection-product-listing .cpl-entry a").each(function () {
          let il = "/products/unusual-shape";
          let cl = $(this).attr("href");
          // if (cl == il) {
          //   $(this).attr("href", "/pages/custom-or-unusual-size");
          // }
        });
      }
    }

    /* cart ajax */

    function addToCartOk(product) {
      window.location.href = "/cart";
    }

    function addToCartFail(obj, status) {
      alert(
        "There was an error. Please try again or contact us at (800) 979-2984"
      );
    }

    const removeItemFromCart = (productID) => {
      let formData = {
        updates: {
          [parseInt(productID)]: 0,
        },
      };
      let info = fetch("/cart/update.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      })
        .then((response) => response.json())
        .then((data) => {
          return data;
        })
        .catch((error) => {
          console.error("Error:", error);
        });
    };

    $(document).on("click", ".on-select-messages a", function () {
      let parentClass = $(this).parent().parent().attr("data-parent");
      let correction = -64;
      $("html,body").animate(
        { scrollTop: $(".pc-entry." + parentClass).offset().top + correction },
        1000
      );
      if ($(this).parent().parent().attr("data-recom").length > 0) {
        let wta = $(this).parent().parent().attr("data-recom");
        $(".pc-entry." + wta + " .action-button .button").addClass("tada");
        window.setTimeout(function () {
          $(".pc-entry .button").removeClass("tada");
        }, 2000);
      }
      return false;
    });
    $(document).on("click", ".remove-from-cart", function () {
      if (
        $(this).parent().parent().find(".cart-item-custom-properties").length >
        0
      ) {
        let cid = $(this).attr("data-curid");
        var liftplatesidE = $(this)
          .parent()
          .parent()
          .find(".cart-item-custom-properties p .liftplatesid");
        var liftplatesid = liftplatesidE
          .parent()
          .text()
          .replace("liftplatesid:", "")
          .replace(/\s/g, "");
        var addonId1E = $(this)
          .parent()
          .parent()
          .find(".cart-item-custom-properties p .addonId1");
        var addonId1id = addonId1E
          .parent()
          .text()
          .replace("addonId1:", "")
          .replace(/\s/g, "");
        var addonId2E = $(this)
          .parent()
          .parent()
          .find(".cart-item-custom-properties p .addonId2");
        var addonId2id = addonId2E
          .parent()
          .text()
          .replace("addonId2:", "")
          .replace(/\s/g, "");
        var addonId3E = $(this)
          .parent()
          .parent()
          .find(".cart-item-custom-properties p .addonId3");
        var addonId3id = addonId3E
          .parent()
          .text()
          .replace("addonId3:", "")
          .replace(/\s/g, "");

        const removeSeveralFromCart = (...productIDS) => {
          let formData = {
            updates: {},
          };

          var productID;
          for (var index = 0; index < productIDS.length; index++) {
            if (!productIDS[index]) {
              productIDS.splice(index, 1);
              index--;
            } else {
              formData["updates"][parseInt(productIDS[index])] = 0;
            }
          }

          let info = fetch("/cart/update.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(formData),
          })
            .then((response) => response.json())
            .then((data) => {
              addToCartOk();
            })
            .catch((error) => {
              addToCartFail();
              console.error("Error:", error);
            });
        };
        removeSeveralFromCart(
          cid,
          addonId3id,
          addonId2id,
          addonId1id,
          liftplatesid
        );
        //removeSeveralFromCart(insulationid, cid);

        return false;
      }
    });

    if ($(".cart-item-custom-properties").length > 0) {
      $(".cart-item-custom-properties p").each(function () {
        if (!$("strong", this).hasClass("to-hide")) {
          $(this).removeClass("hidden");
        }
        //$(this).removeClass("hidden");
      });
    }

    $(".spw-right.spa-cover #AddToCartForm").submit(function (e) {
      event.preventDefault();
    });

    /* add to cart logic */
    if ($("body").hasClass("product") && $(".main-product-spa").length > 0) {
      let cpt = $(".spw-right h1 .main-product-name").text();
      // if (cpt == "Oversized and Custom Shape Spa Cover") {
      //   window.location.href = "/pages/custom-or-unusual-size";
      // }
      if (cpt == "Spa Cover & Hot Tub Cover Replacement") {
        window.location.href = "https://www.myspacover.com/collections/all";
      }
      if (
        cpt == "Rounded Rectangle Spa Cover" ||
        cpt == "Four Corners Spa Cover" ||
        cpt == "One Cut Corner Spa Cover" ||
        cpt == "Spa Cover & Hot Tub Cover Replacement"
      ) {
        $(
          ".pdw-block.dim-b, .pdw-block.dim-c, .pdw-block.cover-fold"
        ).removeClass("hidden");
        $(
          ".properties-dd-selectors .properties-dd, .properties-dd-selectors .pdw-block"
        ).removeClass("hidden");
        $(".oversize-fee").removeClass("hidden");
      }
      if (cpt == "Elliptical Spa Cover" || cpt == "Square Spa Cover") {
        $(".pdw-block.dim-b, .pdw-block.cover-fold").removeClass("hidden");
        $(
          ".properties-dd-selectors .properties-dd, .properties-dd-selectors .pdw-block"
        ).removeClass("hidden");
        $(".oversize-fee").removeClass("hidden");
      }
      if (cpt == "Octagon Spa Cover") {
        $(".pdw-block.dim-b").removeClass("hidden");
        $(
          ".properties-dd-selectors .properties-dd, .properties-dd-selectors .pdw-block"
        ).removeClass("hidden");
        $(".oversize-fee").removeClass("hidden");
      }
      if (cpt == "Circle Spa Cover") {
        $(
          ".properties-dd-selectors .properties-dd, .properties-dd-selectors .pdw-block"
        ).removeClass("hidden");
        $(".oversize-fee").removeClass("hidden");
      }
      window.prodToCart = new Array();
      //window.pprice = new Number($("#insdur-selector li:first").attr("data-price"));
      window.pprice = 0;
      //window.cprodid = $("#insdur-selector li:first").attr("data-id");
      window.cprodid = "";
      //$(".product-total-price strong").text("$"+window.pprice);
    }
    if ($(".predefined-product-values").length > 0) {
      let dima = $(".predefined-product-values .dima").text();
      let dimb = $(".predefined-product-values .dimb").text();
      let dimc = $(".predefined-product-values .dimc").text();
      let skirtlen = $(".predefined-product-values .skirtlen").text();
      let straplen = $(".predefined-product-values .straplen").text();
      let coverfold = $(".predefined-product-values .coverfold").text();
      if (dima && dima > 0) {
        $("#dima").prop("readonly", true);
        $("#dima").val(dima);
        if (dima > 96) {
          $(".oversize-fee").removeClass("hidden");
        }
      }
      if (dimb && dimb > 0) {
        $(".pdw-block.dim-b").removeClass("hidden");
        $("#dimb").prop("readonly", true);
        $("#dimb").val(dimb);
        if (dimb > 96) {
          $(".oversize-fee").removeClass("hidden");
        }
      }
      if (dimc && dimc > 0) {
        $(".pdw-block.dim-c").removeClass("hidden");
        $("#dimc").prop("readonly", true);
        $("#dimc").val(dimc);
      }
      if (skirtlen) {
        $("#skirtlen").find("option:selected").prop("selected", false);
        $("#skirtlen").attr("disabled", true);
        $(".properties-dd-selectors #skirtlenb").val(skirtlen);
        $(
          ".properties-dd-selectors .input-box.skirtlenb, .properties-dd-selectors .pdw-block"
        ).removeClass("hidden");
      }
      if (straplen) {
        $("#straplen").find("option:selected").prop("selected", false);
        $("#straplen").attr("disabled", true);
        $(".properties-dd-selectors #straplenb").val(straplen);
        $(
          ".properties-dd-selectors .input-box.straplenb, .properties-dd-selectors .pdw-block"
        ).removeClass("hidden");
      }
      if (coverfold == "true") {
        $(".pdw-block.cover-fold").removeClass("hidden");
      }
    }
    //window.prodToCart

    $(document).on("click", ".product-cols .action-button a", function () {
      if ($(this).hasClass("cover-addons-select")) {
        let selVal = $(this).attr("data-foption");

        let addonId = $(
          '#cvraddon-selector li[data-title="' + selVal + '"]'
        ).attr("data-id");

        let addonPrice = new Number(
          $('#cvraddon-selector li[data-title="' + selVal + '"]').attr(
            "data-price"
          )
        );

        if ($(this).parent().hasClass("selected")) {
          window.pprice = window.pprice - addonPrice;
          $(this).parent().removeClass("selected");
          $(this).parent().parent().removeClass("selected");
          $(".product-total-price strong").text("$" + window.pprice.toFixed(2));
          window.prodToCart = $.grep(window.prodToCart, function (e) {
            return e.id != addonId;
          });
        } else {
          window.pprice = window.pprice + addonPrice;
          $(this).parent().addClass("selected");
          $(this).parent().parent().addClass("selected");
          $(".product-total-price strong").text("$" + window.pprice.toFixed(2));
          window.prodToCart.push({
            id: addonId,
            quantity: 1,
          });
        }
      }
      if ($(this).hasClass("insulation-durability-select")) {
        if ($(".select-insulation-durability .error").length > 0) {
          $(".select-insulation-durability .error").remove();
        }
        if ($("#dima").val() > 96 || $("#dimb").val() > 96) {
          let ofeeid = $("#ofee-selector .variant-info").attr("data-id");
          let ofeep = new Number(
            $("#ofee-selector .variant-info").attr("data-price")
          );
          window.pprice = ofeep;
          window.prodToCart.push({
            id: ofeeid,
            quantity: 1,
          });
          window.ofee = "true";
        }

        if ($(".product-final-info .product-total-price").hasClass("hidden")) {
          $(".product-final-info .product-total-price").removeClass("hidden");
        }
        let wmts = $(this).attr("data-message");
        if ($(".on-select-messages .copy-block." + wmts).length > 0) {
          $(".on-select-messages .copy-block").addClass("hidden");
          $(".on-select-messages .copy-block." + wmts).removeClass("hidden");
        } else {
          if ($(".on-select-messages .copy-block").length > 0) {
            $(".on-select-messages .copy-block").addClass("hidden");
          }
        }
        if (
          $(".product-cols.insulation-durability  .action-button").hasClass(
            "selected"
          )
        ) {
          $(".product-cols .durability-blocks .action-button").removeClass(
            "selected"
          );
          let selValI = $(
            ".product-cols.insulation-durability  .action-button.selected a"
          ).attr("data-foption");
          let insdurPriceI = new Number(
            $('#insdur-selector li[data-title="' + selValI + '"]').attr(
              "data-price"
            )
          );
          let insdurIdI = new Number(
            $('#insdur-selector li[data-title="' + selValI + '"]').attr(
              "data-id"
            )
          );

          if (window.pprice > 0) {
            window.pprice = window.pprice + insdurPriceI;
          } else {
            window.pprice = insdurPriceI;
          }
          window.prodToCart = $.grep(window.prodToCart, function (e) {
            return e.id != insdurIdI;
          });
          $(".product-total-price strong").text("$" + window.pprice.toFixed(2));
          $(
            ".product-cols .insulation-durability  .action-button .selected"
          ).removeClass("selected");
          let selVal = $(this).attr("data-foption");
          let insdurId = $(
            '#insdur-selector li[data-title="' + selVal + '"]'
          ).attr("data-id");
          let insdurPrice = new Number(
            $('#insdur-selector li[data-title="' + selVal + '"]').attr(
              "data-price"
            )
          );
          console.log("i ma in if");
          window.pprice = insdurPrice;
          $(".product-total-price strong").text("$" + window.pprice.toFixed(2));
          $(this).parent().addClass("selected");
          $("#insdur").find("option:selected").prop("selected", false);
          $("#insdur option[value='" + selVal + "']").prop("selected", true);
          /*
              window.prodToCart.push({
                "id": insdurId,
                "quantity": 1
              });
              */
          window.cprodid = insdurId;
        } else {
          let selVal = $(this).attr("data-foption");
          console.log("i ma in else");
          let insdurId = $(
            '#insdur-selector li[data-title="' + selVal + '"]'
          ).attr("data-id");
          let insdurPrice = new Number(
            $('#insdur-selector li[data-title="' + selVal + '"]').attr(
              "data-price"
            )
          );
          if (window.pprice > 0) {
            window.pprice = window.pprice + insdurPrice;
          } else {
            window.pprice = insdurPrice;
          }
          $(".product-total-price strong").text("$" + window.pprice.toFixed(2));
          $(this).parent().addClass("selected");
          $("#insdur").find("option:selected").prop("selected", false);
          $("#insdur option[value='" + selVal + "']").prop("selected", true);
          /*
              window.prodToCart.push({
                "id": insdurId,
                "quantity": 1
              });
              */
          window.cprodid = insdurId;
        }
      }

      if ($(this).hasClass("lifter-plate-select")) {
        let selVal = $(this).attr("data-foption");

        let addonId = $(
          '#lftplt-selector li[data-title="' + selVal + '"]'
        ).attr("data-id");

        let addonPrice = new Number(
          $('#lftplt-selector li[data-title="' + selVal + '"]').attr(
            "data-price"
          )
        );
        let selectedItem = $(".lifter-image-container").find(".selected");

        if ($(this).parent().hasClass("selected")) {
          window.pprice = window.pprice - addonPrice;
          $(this).parent().removeClass("selected");

          $(this)
            .parent()
            .parent()
            .parent()
            .find(".selected")
            .each(function () {
              $(this).removeClass("selected"); // Remove selected from each child
            });
          $(".product-total-price strong").text("$" + window.pprice.toFixed(2));
          window.prodToCart = $.grep(window.prodToCart, function (e) {
            return e.id != addonId;
          });
        } else {
          const oldAddonPrice = $(".lifter.selected").attr("data-price");

          if ($(".lifter.selected").length != 0) {
            window.pprice = window.pprice - 65;
          }

          window.pprice = window.pprice + addonPrice;
          $(".lifter-image-container")
            .find(".selected")
            .removeClass("selected");
          $(this).parent().addClass("selected");
          $(this).parent().parent().addClass("selected");
          $(".product-total-price strong").text("$" + window.pprice.toFixed(2));
          window.prodToCart.push({
            id: addonId,
            quantity: 1,
          });
        }
      }
      return false;
    });

    function getObjects(obj, key, val) {
      var objects = [];
      for (var i in obj) {
        if (!obj.hasOwnProperty(i)) continue;
        if (typeof obj[i] == "object") {
          objects = objects.concat(getObjects(obj[i], key, val));
        } else if (i == key && obj[key] == val) {
          objects.push(obj);
        }
      }
      return objects;
    }

    $(document).on("click", ".spw-right.spa-cover #AddToCart", function () {
      /* add to cart button */
      let selInsulation = $("#insdur").find("option:selected").val();
      if (window.cprodid == "" && selInsulation == "") {
        let correction = -64;
        $("html,body").animate(
          {
            scrollTop:
              $(".select-insulation-durability").offset().top + correction,
          },
          1000
        );
        // stian
      } else {
        var curPrdIndex = window.prodToCart
          .map(function (d) {
            return d["id"];
          })
          .indexOf(window.cprodid);
        if (curPrdIndex == -1) {
          window.prodToCart.push({
            id: window.cprodid,
            quantity: 1,
            properties: {},
          });
          var curPrdIndex = window.prodToCart
            .map(function (d) {
              return d["id"];
            })
            .indexOf(window.cprodid);
        }
      }
      let selPInsulation = $("#insdur").find("option:selected").val();
      if (selPInsulation != "") {
        if ($(".predefined-product-values").length > 0) {
          var dima = $(".predefined-product-values .dima").text();
          var dimb = $(".predefined-product-values .dimb").text();
          var dimc = $(".predefined-product-values .dimc").text();
          var skirtlen = $(".predefined-product-values .skirtlen").text();
          var straplen = $(".predefined-product-values .straplen").text();
          let coverfold = $(".predefined-product-values .coverfold").text();

          if (dima) {
            window.prodToCart[curPrdIndex].properties["dima"] = dima;
          }
          if (dimb) {
            window.prodToCart[curPrdIndex].properties["dimb"] = dimb;
          }
          if (dimc) {
            window.prodToCart[curPrdIndex].properties["dimc"] = dimc;
          }
          if (skirtlen) {
            window.prodToCart[curPrdIndex].properties["skirtlen"] = skirtlen;
          }
          if (straplen) {
            window.prodToCart[curPrdIndex].properties["straplen"] = straplen;
          }

          if (coverfold == "true") {
            let cvrfold = $("#cvrfold").find("option:selected").val();
            if ($("#dima").val() == "") {
              showError(
                "A cover fold option is required; please select a value."
              );
            } else {
              $(".product-details-info .error").remove();
              window.prodToCart[curPrdIndex].properties["cvrfold"] = cvrfold;
            }
          }
        } else {
          var dima = $("#dima").val();
          if (dima) {
            $(".product-details-info .error").remove();
            window.prodToCart[curPrdIndex].properties["dima"] = dima;
          } else {
            let correction = -64;
            $("html,body").animate(
              {
                scrollTop: $(".product-details-info").offset().top + correction,
              },
              1000
            );
            $(".product-details-info .error").remove();
            $(".product-details-info").append(
              "<p class='error'>Dimension A is required; please type a value.</p>"
            );
          }
          if (!$(".pdw-block.dim-b").hasClass("hidden")) {
            var dimb = $("#dimb").val();
            if (dimb) {
              $(".product-details-info .error").remove();
              window.prodToCart[curPrdIndex].properties["dimb"] = dimb;
            } else {
              let correction = -64;
              $("html,body").animate(
                {
                  scrollTop:
                    $(".product-details-info").offset().top + correction,
                },
                1000
              );
              $(".product-details-info .error").remove();
              $(".product-details-info").append(
                "<p class='error'>Dimension B is required; please type a value.</p>"
              );
            }
          }
          if (!$(".pdw-block.dim-c").hasClass("hidden")) {
            var dimc = $("#dimc").val();
            if (dimc) {
              $(".product-details-info .error").remove();
              window.prodToCart[curPrdIndex].properties["dimc"] = dimc;
            } else {
              let correction = -64;
              $("html,body").animate(
                {
                  scrollTop:
                    $(".product-details-info").offset().top + correction,
                },
                1000
              );
              $(".product-details-info .error").remove();
              $(".product-details-info").append(
                "<p class='error'>Dimension C is required; please type a value.</p>"
              );
            }
          }
          if (!$(".pdw-block.cover-fold").hasClass("hidden")) {
            var cvrfold = $("#cvrfold").find("option:selected").val();
            if (cvrfold === "") {
              let correction = -64;
              $("html,body").animate(
                {
                  scrollTop:
                    $(".product-details-info").offset().top + correction,
                },
                1000
              );
              $(".product-details-info .error").remove();
              $(".product-details-info").append(
                "<p class='error'>A cover fold option is required; please select a value.</p>"
              );
            } else {
              $(".product-details-info .error").remove();
              window.prodToCart[curPrdIndex].properties["cvrfold"] = cvrfold;
            }
          }
          var skirtlen = $("#skirtlen").find("option:selected").val();
          var straplen = $("#straplen").find("option:selected").val();

          if (skirtlen) {
            window.prodToCart[curPrdIndex].properties["skirtlen"] = skirtlen;
          }
          if (straplen) {
            window.prodToCart[curPrdIndex].properties["straplen"] = straplen;
          }
        }
      }
      var addcomms = $("#addcomms").val();
      if (addcomms) {
        window.prodToCart[curPrdIndex].properties["addcomms"] = addcomms;
      }
      // color select detection
      let colorval = $("#prdclr").find("option:selected").val();

      let wthshldopt = $("#prdwsclr").find("option:selected").val();

      var location = $("#strplocation").find("option:selected").val();
      if (location) {
        window.prodToCart[curPrdIndex].properties["straplocation"] = location;
      }

      // window.prodToCart[curPrdIndex].properties["strplocation"] = location;

      if (
        colorval === "" &&
        !$("#wtshield option:selected").attr("data-price")
      ) {
        let correction = -64;
        $("html,body").animate(
          { scrollTop: $(".select-a-color").offset().top + correction },
          1000
        );
        $(".select-a-color .error").remove();
        $(".select-a-color").append(
          "<p class='error'>This option is required; please select a value.</p>"
        );
      } else if (
        /*
          else if (colorval === '' && $("#wtshield option:selected").length > 0 && $("#wtshield option:selected").attr("data-price")) {
            // stian
            let cparr = new Array();
           
            $(".select-a-color .error").remove();
            let cwss = $("#wtshield option:selected").val();
            if(cwss != "") {
            
              
              cparr = window.prodToCart;
              
              for(x in cparr) {
                if(cparr[x].id != cwss) {
                
                  window.prodToCart.push({
                    "id": cwss,
                    "quantity": 1,
                  });
                }
              }
              
              cparr.forEach((element, index, array) => {
                if(element.id !== cwss) {
                  cparr.push({
                    "id": cwss,
                    "quantity": 1,
                  });
                }
              });
    
            }
          }
          */
        colorval.length > 0 &&
        !$("#wtshield option:selected").attr("data-price")
      ) {
        $(".select-a-color .error").remove();
        window.prodToCart[curPrdIndex].properties["color"] = colorval;
      }

      /*
          if(wthshldopt !== '') {
            window.prodToCart[curPrdIndex].properties["weatherguard"] = wthshldopt;
          }
          */

      let liftPlates = $("#install-lift-plates").prop("checked");
      if (liftPlates == true) {
        let platesId = $("#lftplt-selector li:first").attr("data-id");
        // window.prodToCart[curPrdIndex].properties["liftplatesid"] = platesId;
      }
      let insdur = $("#insdur").find("option:selected").val();
      if (insdur === "") {
        let correction = -64;
        $("html,body").animate(
          {
            scrollTop:
              $(".select-insulation-durability").offset().top + correction,
          },
          1000
        );
        $(".select-insulation-durability .error").remove();
        $(".select-insulation-durability").append(
          "<p class='error'>This option is required; please select a value.</p>"
        );
      } else {
        $(".select-insulation-durability .error").remove();
        //let insulationId = $('#insdur-selector li[data-title="'+insdur+'"]').attr("data-id");
        //window.prodToCart[curPrdIndex].properties["insulationid"] = insulationId;
      }

      var count = 0;

      $(".product-cols.cover-addons .pc-entry").each(function () {
        if ($(".info-block", this).hasClass("selected")) {
          count++;
          var addonType = $(".info-block .action-button a", this).attr(
            "data-foption"
          );
          var addonId = $(
            '#cvraddon-selector li[data-title="' + addonType + '"]'
          ).attr("data-id");
          window.prodToCart[curPrdIndex].properties["addonId" + count] =
            addonId;
          var coverIndex = window.prodToCart
            .map(function (d) {
              return d["id"];
            })
            .indexOf(addonId);
          if (coverIndex == -1) {
            window.prodToCart.push({
              id: addonId,
              quantity: 1,
            });
            var coverIndex = window.prodToCart
              .map(function (d) {
                return d["id"];
              })
              .indexOf(addonId);
          }
        }
      });
      var selectedClass = $("#shopify-section-lifter-plate").find(".selected");

      if (!$("#install-lift-plates").is(":checked") || selectedClass.length) {
        $(".product-lifter-info .error").remove(); // Remove error if it exists
      } else {
        // If the checkbox is not checked, handle accordingly
        if ($(".product-lifter-info .error").length === 0) {
          $(".product-lifter-info").append(
            "<p class='error'>Please select a lifter plate.</p>"
          );
        }
      }

      function showError(message) {
        let correction = -84;
        $("html,body").animate(
          {
            scrollTop: $(".product-details-info").offset().top + correction,
          },
          1000
        );
        $(".product-details-info .error").remove();
        $(".product-details-info").append(`<p class='error'>${message}</p>`);
      }

      if ($("#dima").val() == "") {
        showError("Dim A is required; Please type a value.");
      } else if ($("#dimb").val() == "" && !$(".dim-b").hasClass("hidden")) {
        showError("Dim B is required; Please type a value.");
      } else if ($("#dimc").val() == "" && !$(".dim-c").hasClass("hidden")) {
        showError("Dim C is required; Please type a value.");
      }

      if ($(".spw-right .error").length <= 0) {
        let dima = $("#dima").val();
        let dimb = $("#dimb").val();
        if (dima > 104 || dimb > 104) {
          $(
            ".oversize-fee.red-text, .product-final-info, .on-select-messages .copy-block"
          ).addClass("hidden");
          $(".custom-version.red-text, .contact-us-form").removeClass("hidden");
          return false;
        } else {
          if (window.ofee != "true" || window.ofee != undefined) {
            if ($("#dima").val() > 96 || $("#dimb").val() > 96) {
              let ofeeid = $("#ofee-selector .variant-info").attr("data-id");
              let ofeep = new Number(
                $("#ofee-selector .variant-info").attr("data-price")
              );
              window.pprice = ofeep;
              window.prodToCart.push({
                id: ofeeid,
                quantity: 1,
              });
            }
          }

          jQuery.ajax({
            type: "POST",
            url: "/cart/add.js",
            data: { items: window.prodToCart },
            dataType: "json",
            success: addToCartOk,
            error: addToCartFail,
          });

          //addToCartOk();
        }
      }

      return false;
    });

    if ($("#accessories-listing").length > 0) {
      function accPrdList() {
        console.log(response);
      }
      jQuery.ajax({
        type: "GET",
        url: "/admin/api/2021-04/collections/263474282692/products.json",
        dataType: "json",
        success: function (data) {
          let products = data.products;
          for (x in data.products) {
            $("#accessories-listing").append(
              "<p>" +
                data.products[x].id +
                " - " +
                data.products[x].title +
                "</p>"
            );
          }
        },
        error: addToCartFail,
      });
    }

    $(document).on("click", ".checker span", function () {
      $(this)
        .parent()
        .find("input[type=checkbox]")
        .attr("checked", function (_, attr) {
          return !attr;
        });
    });
    $(document).on("click", ".video-overlay-trigger", function () {
      $(".modal.video").toggleClass("visible");
      if ($(this).attr("data-vid")) {
        let vid = $(this).attr("data-vid");
        $(".modal.video .modal-video-content").append(
          '<iframe width="560" height="315" src="https://www.youtube.com/embed/' +
            vid +
            '?controls=0&autoplay=1" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>'
        );
      }
      return false;
    });
    $(document).on("click", ".show-lift-plates-info", function () {
      let modalCopy = $("#lftplt-selector .variant-copy").html();
      $(".modal.info-modal.simple .info-modal-copy").append(modalCopy);
      $(".modal.info-modal.simple").addClass("visible");
      return false;
    });
    $(document).on("click", ".show-addon-info", function () {
      let modalCopy = $(this).parent().parent().find(".modal-info").html();
      $(".modal.info-modal .info-modal-copy").append(modalCopy);
      $(".modal.info-modal.simple").addClass("visible");
      return false;
    });
    $(document).on("click", ".ic-item.us-vs-them", function () {
      $(".modal.us-vs-them").addClass("visible");
      return false;
    });
    $(document).on("click", ".collection .sidebar-extra-copy a", function () {
      let tt = $(this).attr("href");
      if (tt == "#us-vs-them") {
        $(".modal.us-vs-them").addClass("visible");
        return false;
      }
    });

    $(document).on("click", ".modal .close", function () {
      $(this).parent().parent().toggleClass("visible");
      if ($(this).parent().parent().hasClass("video")) {
        $(".modal.video .modal-video-content").empty();
      }
      if ($(this).parent().parent().hasClass("info-modal")) {
        $(".modal.info-modal.simple .info-modal-copy").empty();
      }
      return false;
    });
    if ($("#shopify-section-cmpr-1")) {
      $("#shopify-section-cmpr-1 .ct-entry:first h3").addClass("text-logo");
      $("#shopify-section-cmpr-1 .ct-entry:first h3:contains(Spa)").html(
        function () {
          return $(this).html().replace("Spa", "<span>Spa</span>");
        }
      );
    }
    $(document).on("click", ".toggle-hidden", function () {
      $(".form-wrapper .hidden").removeClass("hidden");
      $(".form-wrapper .to-hide").addClass("hidden").removeClass("to-hide");
      return false;
    });
    $(document).on(
      "click",
      ".collection-product-listing .image-stripe .is-entry",
      function () {
        let ci = $(this).attr("style");
        let itb = $(this).parent().parent().find(".main-image").attr("style");
        $(this).attr("style", itb);
        $(this).parent().parent().find(".main-image").attr("style", ci);
      }
    );
    $(document).on("click", ".spw-left .image-stripe .is-entry", function () {
      let ci = $(this).attr("style");
      let itb = $(".dpi-wrapper .inner-image").attr("style");
      $(this).attr("style", itb);
      $(".dpi-wrapper .inner-image").attr("style", ci);
    });
    $(".collection-variant-selector").on("change", function (e) {
      let fprice = $(this).find("option:selected").data("price");
      let name = $(this).find("option:selected").data("name");
      $(this).parent().parent().find(".product-title-row").text(name);
      $(this)
        .parent()
        .parent()
        .find(".product-pricing-row span:nth-of-type(1)")
        .text(fprice);
      if ($(this).find("option:selected").data("compare")) {
        let oprice = $(this).find("option:selected").data("compare");
        $(this)
          .parent()
          .parent()
          .find(".product-pricing-row span:nth-of-type(2)")
          .text(oprice);
      } else {
        $(this)
          .parent()
          .parent()
          .find(".product-pricing-row span:nth-of-type(2)")
          .text("");
      }
      e.preventDefault();
    });
    $(".product-variant-selector").on("change", function () {
      let fprice = $(this).find("option:selected").data("price");
      $(".product-price strong").text(fprice);
      if ($(this).find("option:selected").data("compare")) {
        let oprice = $(this).find("option:selected").data("compare");
        $(".product-price span").text(oprice);
      }
    });
    $(document).ready(function () {
      var $dimaInput = $(".dima");
      var $dimbInput = $(".dimb");
      var $dimcInput = $(".dimc");
      var $addToCartButton = $("#AddToCart");

      function checkValues() {
        var dimaValue = parseFloat($dimaInput.val()) || 0;
        var dimbValue = parseFloat($dimbInput.val()) || 0;
        var dimcValue = parseFloat($dimcInput.val()) || 0;

        if (dimaValue > 96 || dimbValue > 96 || dimcValue > 96) {
          alert(
            "You have entered over 96 and it is considered as an oversized. Please contact us."
          );
          $addToCartButton.text("Contact Us");
        } else {
          $addToCartButton.text("Add to Cart");
        }
      }

      // Listen for input events on both input fields
      $dimaInput.on("input", checkValues);
      $dimbInput.on("input", checkValues);
      $dimcInput.on("input", checkValues);
      $addToCartButton.on("click", function (e) {
        if ($addToCartButton.text() === "Contact Us") {
          e.preventDefault(); // Prevent the default button action
          window.location.href = "https://www.myspacover.com/pages/contact"; // Redirect to the contact page
        }
      });
    });

    // strap location
    $(document).on("click", ".strap-options", function () {
      var radioInput = $(this).find('input[type="radio"]');
      var selectedValue = radioInput.val();
      radioInput.prop("checked", true);

      if ($(this).parent().hasClass("extra-label")) {
        $(this).parent().find("span").removeClass("selected");
        $(this).addClass("selected");
        if (
          $(".straplocations").find("option:selected").text() == selectedValue
        ) {
          $(this).removeClass("selected");
          $(".straplocations").prop("selectedIndex", 0);
        } else {
          $(this)
            .parent()
            .parent()
            .find(".straplocations option:selected")
            .prop("selected", false);
          $(this)
            .parent()
            .parent()
            .find(".straplocations  option[value='" + selectedValue + "']")
            .prop("selected", true);
        }
      }
      var strapLocation = $("#strplocation").find("option:selected").val();

      return false;
    });

    let clicked = false;

    $(".load-more").on("click", function (e) {
      // Toggle the visibility of the .second-color-div
      $(".second-color-div").toggle();

      // Clear the selected text (for text selection)
      if (window.getSelection) {
        window.getSelection().removeAllRanges();
      } else if (document.selection) {
        document.selection.empty();
      }

      // Update the button text based on the clicked state
      if (!clicked) {
        $(this).text("Hide Color Options");
        // Clear the select box selection with ID 'prdclr' only when the text is "Hide"
        $("#prdclr").prop("selectedIndex", 0);
        $(".product-color-selector a.selected").removeClass("selected");
        clicked = true;
      } else {
        $(this).text("Load More Color Options");
        $(".product-color-selector a.selected").removeClass("selected");
        clicked = false;
      }
    });

    // custom js for product slider

    $("#product-slider").owlCarousel({
      loop: true,
      margin: 10,
      responsiveClass: true,
      autoplay: false,
      nav: false,
      dots: false,
      responsive: {
        0: {
          items: 1,
        },
        600: {
          items: 1,
        },
        1000: {
          items: 1,
        },
      },
    });

    $("#slider-thumbs").owlCarousel({
      loop: false,
      margin: 10,
      responsiveClass: true,
      autoplay: false,
      nav: true,
      dots: false,
      responsive: {
        0: {
          items: 5,
        },
        600: {
          items: 5,
        },
        1000: {
          items: 5,
        },
      },
    });

    const inputElementA = document.getElementById("dima");

    if (inputElementA) {
      // Add click event listener to each input element
      inputElementA.addEventListener("click", () => {
        // Trigger click event on the element with ID 'slide3'
        changeSlideOnClick(4);
      });
    }

    const inputElementB = document.getElementById("dimb");
    if (inputElementB) {
      // Add click event listener to each input element
      inputElementB.addEventListener("click", () => {
        // Trigger click event on the element with ID 'slide3'
        changeSlideOnClick(5);
      });
    }

    const inputElementC = document.getElementById("dimc");
    if (inputElementC) {
      // Add click event listener to each input element
      inputElementC.addEventListener("click", () => {
        // Trigger click event on the element with ID 'slide3'
        changeSlideOnClick(6);
      });
    }

    function changeSlideOnClick(slideIndex) {
      $("#product-slider").trigger("to.owl.carousel", [slideIndex, 300]);
    }

    if (document.getElementById("cvrfold")) {
      document
        .getElementById("cvrfold")
        .addEventListener("change", function (event) {
          event.preventDefault();
          const selectedValue = event.target.value;
          if (selectedValue === "Fold A") {
            // slide3Button.click();
            changeSlideOnClick(2);
          }
          if (selectedValue === "Fold B") {
            changeSlideOnClick(3);
          }
        });
    }

    $(document).on("click", ".strap-options", function () {
      var radioInput = $(this).find('input[type="radio"]');
      var selectedValue = radioInput.val();
      var slide7Button = document.getElementById("slide8");
      var slide8Button = document.getElementById("slide9");
      var slide9Button = document.getElementById("slide10");
      var slide10Button = document.getElementById("slide11");

      if (selectedValue === "location_a") {
        changeSlideOnClick(7);
      }
      if (selectedValue === "location_b") {
        changeSlideOnClick(8);
      }
      if (selectedValue === "location_c") {
        changeSlideOnClick(9);
      }
      if (selectedValue === "location_d") {
        changeSlideOnClick(10);
      }
    });

    $("#slider-thumbs .thumbs").each(function (index) {
      $(this).on("click", function () {
        changeSlideOnClick(index);
      });
    });

    $(".dynamic-button p").click(function () {
      if ($(this).attr("id") === "customize") {
        $(this).attr("id", "pre-defined").text("Pre Defined");
        $("#section-1").hide();
        $("#section-2").show();
      } else {
        $(this).attr("id", "customize").text("Customize");

        $("#section-2").hide();
        $("#section-1").show();
      }
    });
    // $("#install-lift-plates").on("change", function () {
    //   const modal = $(".info-modal"); // Select the element with the class 'info-modal'
    //   if ($(this).is(":checked")) {
    //     let modalCopy = $("#lftplt-selector .variant-copy").html();
    //     $(".modal.info-modal.simple .info-modal-copy").append(modalCopy);
    //     $(".modal.info-modal.simple").addClass("visible");
    //     modal.addClass("visible");
    //   } else {
    //     modal.removeClass("visible");
    //   }
    // });

    // $("#install-lift-plates").on("change", function () {
    //   const modal = $(".info-modal"); // Select the element with the class 'info-modal'

    //   // First part: Modal handling
    //   if ($(this).is(":checked")) {
    //     let modalCopy = $("#lftplt-selector .variant-copy").html();
    //     $(".modal.info-modal.simple .info-modal-copy").append(modalCopy);
    //     $(".modal.info-modal.simple").addClass("visible");
    //     modal.addClass("visible");

    //     // Second part: Price and product handling
    //     let platesId = $(
    //       '#lftplt-selector li[data-title="Aluminum Lift Plates"]'
    //     ).attr("data-id");

    //     let platesPrice = new Number(
    //       $('#lftplt-selector li[data-title="Aluminum Lift Plates"]').attr(
    //         "data-price"
    //       )
    //     );
    //     window.pprice = window.pprice + platesPrice;
    //     $(".product-total-price strong").text("$" + window.pprice.toFixed(2));
    //     window.prodToCart.push({
    //       id: platesId,
    //       quantity: 1,
    //     });
    //   } else {
    //     // Remove modal and reset values
    //     modal.removeClass("visible");

    //     let platesPrice = new Number(
    //       $('#lftplt-selector li[data-title="Aluminum Lift Plates"]').attr(
    //         "data-price"
    //       )
    //     );
    //     let platesId = $(
    //       '#lftplt-selector li[data-title="Aluminum Lift Plates"]'
    //     ).attr("data-id");
    //     window.pprice = window.pprice - platesPrice;
    //     $(".product-total-price strong").text("$" + window.pprice.toFixed(2));
    //     window.prodToCart = $.grep(window.prodToCart, function (e) {
    //       return e.id != platesId;
    //     });
    //   }
    // });

    $("#install-lift-plates").on("change", function () {
      if ($(this).is(":checked")) {
        $(".lifter-container").css("display", "block");
      } else {
        $(".lifter-container").css("display", "none");
      }
    });

    let isVisible = false; // State to track visibility

    $("#detail-read-more-btn").click(function () {
      if (isVisible) {
        $(".read-more-content").hide(); // Hides the content
        $("#detail-read-more-btn").text("View More");
      } else {
        $(".read-more-content").show(); // Shows the content
        $("#detail-read-more-btn").text("View Less");
      }
      isVisible = !isVisible; // Toggles the state
    });
  })($);
};
